var map = {
	"./templates/panels.json": "cEu5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iOTW";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/sitebuilder ^\.\/.*\/panels\.json$
// module id = iOTW
// module chunks = 0